(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["social"] && !Shopify.designMode) return;
  try {
    const copyLesWooShareUrl = async (url) => {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(url);
        return;
      } catch (error) {
        // Fall back for browsers and embedded previews that deny Clipboard API access.
      }
    }

    const temporaryInput = document.createElement('textarea');
    temporaryInput.value = url;
    temporaryInput.setAttribute('readonly', '');
    temporaryInput.style.position = 'fixed';
    temporaryInput.style.opacity = '0';
    document.body.appendChild(temporaryInput);
    temporaryInput.select();

    const copied = document.execCommand('copy');
    temporaryInput.remove();

    if (!copied) throw new Error('Copy command was not accepted');
  };

  document.addEventListener('click', async (event) => {
    const nativeButton = event.target.closest('[data-native-share]');
    const copyButton = event.target.closest('[data-copy-link]');

    if (nativeButton) {
      try {
        await navigator.share({
          title: nativeButton.dataset.shareTitle,
          url: nativeButton.dataset.shareUrl
        });
      } catch (error) {
        if (error.name !== 'AbortError') console.error(error);
      }
    }

    if (copyButton) {
      const wrapper = copyButton.closest('[data-leswoo-share]');
      const status = wrapper.querySelector('.leswoo-share__status');

      try {
        await copyLesWooShareUrl(copyButton.dataset.shareUrl);
        status.textContent = copyButton.dataset.copiedLabel;
        copyButton.setAttribute('aria-label', copyButton.dataset.copiedLabel);
        window.setTimeout(() => {
          status.textContent = '';
          copyButton.setAttribute('aria-label', copyButton.dataset.copyLabel);
        }, 1800);
      } catch (error) {
        console.error(error);
      }
    }
  });

  document.querySelectorAll('[data-native-share]').forEach((button) => {
    if (navigator.share) button.hidden = false;
  });
  } catch(e) { console.error(e); }
})();

})();
